export default {
    props: {
        xAxisAxisCrossingValue: {
            type: Object | Date | Array,
            kComposite: 'xAxis.axisCrossingValue'
        }, 
        xAxisBackground: {
            type: String,
            kComposite: 'xAxis.background'
        }, 
        xAxisBaseUnit: {
            type: String,
            kComposite: 'xAxis.baseUnit'
        }, 
        xAxisColor: {
            type: String,
            kComposite: 'xAxis.color'
        }, 
        xAxisCrosshairColor: {
            type: String,
            kComposite: 'xAxis.crosshair.color'
        }, 
        xAxisCrosshairOpacity: {
            type: Number,
            kComposite: 'xAxis.crosshair.opacity'
        }, 
        xAxisCrosshairTooltipBackground: {
            type: String,
            kComposite: 'xAxis.crosshair.tooltip.background'
        }, 
        xAxisCrosshairTooltipBorderColor: {
            type: String,
            kComposite: 'xAxis.crosshair.tooltip.border.color'
        }, 
        xAxisCrosshairTooltipBorderDashType: {
            type: String,
            kComposite: 'xAxis.crosshair.tooltip.border.dashType'
        }, 
        xAxisCrosshairTooltipBorderWidth: {
            type: Number,
            kComposite: 'xAxis.crosshair.tooltip.border.width'
        }, 
        xAxisCrosshairTooltipColor: {
            type: String,
            kComposite: 'xAxis.crosshair.tooltip.color'
        }, 
        xAxisCrosshairTooltipFont: {
            type: String,
            kComposite: 'xAxis.crosshair.tooltip.font'
        }, 
        xAxisCrosshairTooltipFormat: {
            type: String,
            kComposite: 'xAxis.crosshair.tooltip.format'
        }, 
        xAxisCrosshairTooltipPadding: {
            type: Number,
            kComposite: 'xAxis.crosshair.tooltip.padding'
        }, 
        xAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            kComposite: 'xAxis.crosshair.tooltip.padding.bottom'
        }, 
        xAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            kComposite: 'xAxis.crosshair.tooltip.padding.left'
        }, 
        xAxisCrosshairTooltipPaddingRight: {
            type: Number,
            kComposite: 'xAxis.crosshair.tooltip.padding.right'
        }, 
        xAxisCrosshairTooltipPaddingTop: {
            type: Number,
            kComposite: 'xAxis.crosshair.tooltip.padding.top'
        }, 
        xAxisCrosshairTooltipTemplate: {
            type: String | Function,
            kComposite: 'xAxis.crosshair.tooltip.template'
        }, 
        xAxisCrosshairTooltipVisible: {
            type: Boolean,
            kComposite: 'xAxis.crosshair.tooltip.visible'
        }, 
        xAxisCrosshairVisible: {
            type: Boolean,
            kComposite: 'xAxis.crosshair.visible'
        }, 
        xAxisCrosshairWidth: {
            type: Number,
            kComposite: 'xAxis.crosshair.width'
        }, 
        xAxisLabelsBackground: {
            type: String,
            kComposite: 'xAxis.labels.background'
        }, 
        xAxisLabelsBorderColor: {
            type: String,
            kComposite: 'xAxis.labels.border.color'
        }, 
        xAxisLabelsBorderDashType: {
            type: String,
            kComposite: 'xAxis.labels.border.dashType'
        }, 
        xAxisLabelsBorderWidth: {
            type: Number,
            kComposite: 'xAxis.labels.border.width'
        }, 
        xAxisLabelsColor: {
            type: String,
            kComposite: 'xAxis.labels.color'
        }, 
        xAxisLabelsCulture: {
            type: String,
            kComposite: 'xAxis.labels.culture'
        }, 
        xAxisLabelsDateFormatsDays: {
            type: String,
            kComposite: 'xAxis.labels.dateFormats.days'
        }, 
        xAxisLabelsDateFormatsHours: {
            type: String,
            kComposite: 'xAxis.labels.dateFormats.hours'
        }, 
        xAxisLabelsDateFormatsMonths: {
            type: String,
            kComposite: 'xAxis.labels.dateFormats.months'
        }, 
        xAxisLabelsDateFormatsWeeks: {
            type: String,
            kComposite: 'xAxis.labels.dateFormats.weeks'
        }, 
        xAxisLabelsDateFormatsYears: {
            type: String,
            kComposite: 'xAxis.labels.dateFormats.years'
        }, 
        xAxisLabelsFont: {
            type: String,
            kComposite: 'xAxis.labels.font'
        }, 
        xAxisLabelsFormat: {
            type: String,
            kComposite: 'xAxis.labels.format'
        }, 
        xAxisLabelsMargin: {
            type: Number,
            kComposite: 'xAxis.labels.margin'
        }, 
        xAxisLabelsMarginBottom: {
            type: Number,
            kComposite: 'xAxis.labels.margin.bottom'
        }, 
        xAxisLabelsMarginLeft: {
            type: Number,
            kComposite: 'xAxis.labels.margin.left'
        }, 
        xAxisLabelsMarginRight: {
            type: Number,
            kComposite: 'xAxis.labels.margin.right'
        }, 
        xAxisLabelsMarginTop: {
            type: Number,
            kComposite: 'xAxis.labels.margin.top'
        }, 
        xAxisLabelsMirror: {
            type: Boolean,
            kComposite: 'xAxis.labels.mirror'
        }, 
        xAxisLabelsPadding: {
            type: Number,
            kComposite: 'xAxis.labels.padding'
        }, 
        xAxisLabelsPaddingBottom: {
            type: Number,
            kComposite: 'xAxis.labels.padding.bottom'
        }, 
        xAxisLabelsPaddingLeft: {
            type: Number,
            kComposite: 'xAxis.labels.padding.left'
        }, 
        xAxisLabelsPaddingRight: {
            type: Number,
            kComposite: 'xAxis.labels.padding.right'
        }, 
        xAxisLabelsPaddingTop: {
            type: Number,
            kComposite: 'xAxis.labels.padding.top'
        }, 
        xAxisLabelsRotation: {
            type: Number | String,
            kComposite: 'xAxis.labels.rotation'
        }, 
        xAxisLabelsRotationAlign: {
            type: String,
            kComposite: 'xAxis.labels.rotation.align'
        }, 
        xAxisLabelsRotationAngle: {
            type: Number | String,
            kComposite: 'xAxis.labels.rotation.angle'
        }, 
        xAxisLabelsSkip: {
            type: Number,
            kComposite: 'xAxis.labels.skip'
        }, 
        xAxisLabelsStep: {
            type: Number,
            kComposite: 'xAxis.labels.step'
        }, 
        xAxisLabelsTemplate: {
            type: String | Function,
            kComposite: 'xAxis.labels.template'
        }, 
        xAxisLabelsVisible: {
            type: Boolean,
            kComposite: 'xAxis.labels.visible'
        }, 
        xAxisLabelsVisual: {
            type: Function,
            kComposite: 'xAxis.labels.visual'
        }, 
        xAxisLineColor: {
            type: String,
            kComposite: 'xAxis.line.color'
        }, 
        xAxisLineDashType: {
            type: String,
            kComposite: 'xAxis.line.dashType'
        }, 
        xAxisLineVisible: {
            type: Boolean,
            kComposite: 'xAxis.line.visible'
        }, 
        xAxisLineWidth: {
            type: Number,
            kComposite: 'xAxis.line.width'
        }, 
        xAxisMajorGridLinesColor: {
            type: String,
            kComposite: 'xAxis.majorGridLines.color'
        }, 
        xAxisMajorGridLinesDashType: {
            type: String,
            kComposite: 'xAxis.majorGridLines.dashType'
        }, 
        xAxisMajorGridLinesVisible: {
            type: Boolean,
            kComposite: 'xAxis.majorGridLines.visible'
        }, 
        xAxisMajorGridLinesWidth: {
            type: Number,
            kComposite: 'xAxis.majorGridLines.width'
        }, 
        xAxisMajorGridLinesStep: {
            type: Number,
            kComposite: 'xAxis.majorGridLines.step'
        }, 
        xAxisMajorGridLinesSkip: {
            type: Number,
            kComposite: 'xAxis.majorGridLines.skip'
        }, 
        xAxisMinorGridLinesColor: {
            type: String,
            kComposite: 'xAxis.minorGridLines.color'
        }, 
        xAxisMinorGridLinesDashType: {
            type: String,
            kComposite: 'xAxis.minorGridLines.dashType'
        }, 
        xAxisMinorGridLinesVisible: {
            type: Boolean,
            kComposite: 'xAxis.minorGridLines.visible'
        }, 
        xAxisMinorGridLinesWidth: {
            type: Number,
            kComposite: 'xAxis.minorGridLines.width'
        }, 
        xAxisMinorGridLinesStep: {
            type: Number,
            kComposite: 'xAxis.minorGridLines.step'
        }, 
        xAxisMinorGridLinesSkip: {
            type: Number,
            kComposite: 'xAxis.minorGridLines.skip'
        }, 
        xAxisMinorTicksColor: {
            type: String,
            kComposite: 'xAxis.minorTicks.color'
        }, 
        xAxisMinorTicksSize: {
            type: Number,
            kComposite: 'xAxis.minorTicks.size'
        }, 
        xAxisMinorTicksVisible: {
            type: Boolean,
            kComposite: 'xAxis.minorTicks.visible'
        }, 
        xAxisMinorTicksWidth: {
            type: Number,
            kComposite: 'xAxis.minorTicks.width'
        }, 
        xAxisMinorTicksStep: {
            type: Number,
            kComposite: 'xAxis.minorTicks.step'
        }, 
        xAxisMinorTicksSkip: {
            type: Number,
            kComposite: 'xAxis.minorTicks.skip'
        }, 
        xAxisMajorTicksColor: {
            type: String,
            kComposite: 'xAxis.majorTicks.color'
        }, 
        xAxisMajorTicksSize: {
            type: Number,
            kComposite: 'xAxis.majorTicks.size'
        }, 
        xAxisMajorTicksVisible: {
            type: Boolean,
            kComposite: 'xAxis.majorTicks.visible'
        }, 
        xAxisMajorTicksWidth: {
            type: Number,
            kComposite: 'xAxis.majorTicks.width'
        }, 
        xAxisMajorTicksStep: {
            type: Number,
            kComposite: 'xAxis.majorTicks.step'
        }, 
        xAxisMajorTicksSkip: {
            type: Number,
            kComposite: 'xAxis.majorTicks.skip'
        }, 
        xAxisMajorUnit: {
            type: Number,
            kComposite: 'xAxis.majorUnit'
        }, 
        xAxisMax: {
            type: Number,
            kComposite: 'xAxis.max'
        }, 
        xAxisMin: {
            type: Number,
            kComposite: 'xAxis.min'
        }, 
        xAxisMinorUnit: {
            type: Number,
            kComposite: 'xAxis.minorUnit'
        }, 
        xAxisName: {
            type: String,
            kComposite: 'xAxis.name'
        }, 
        xAxisNarrowRange: {
            type: Boolean,
            kComposite: 'xAxis.narrowRange'
        }, 
        xAxisPane: {
            type: String,
            kComposite: 'xAxis.pane'
        }, 
        xAxisPlotBands: {
            type: Array,
            kComposite: 'xAxis.plotBands'
        },
        xAxisReverse: {
            type: Boolean,
            kComposite: 'xAxis.reverse'
        }, 
        xAxisStartAngle: {
            type: Number,
            kComposite: 'xAxis.startAngle'
        }, 
        xAxisTitleBackground: {
            type: String,
            kComposite: 'xAxis.title.background'
        }, 
        xAxisTitleBorderColor: {
            type: String,
            kComposite: 'xAxis.title.border.color'
        }, 
        xAxisTitleBorderDashType: {
            type: String,
            kComposite: 'xAxis.title.border.dashType'
        }, 
        xAxisTitleBorderWidth: {
            type: Number,
            kComposite: 'xAxis.title.border.width'
        }, 
        xAxisTitleColor: {
            type: String,
            kComposite: 'xAxis.title.color'
        }, 
        xAxisTitleFont: {
            type: String,
            kComposite: 'xAxis.title.font'
        }, 
        xAxisTitleMargin: {
            type: Number,
            kComposite: 'xAxis.title.margin'
        }, 
        xAxisTitleMarginBottom: {
            type: Number,
            kComposite: 'xAxis.title.margin.bottom'
        }, 
        xAxisTitleMarginLeft: {
            type: Number,
            kComposite: 'xAxis.title.margin.left'
        }, 
        xAxisTitleMarginRight: {
            type: Number,
            kComposite: 'xAxis.title.margin.right'
        }, 
        xAxisTitleMarginTop: {
            type: Number,
            kComposite: 'xAxis.title.margin.top'
        }, 
        xAxisTitlePadding: {
            type: Number,
            kComposite: 'xAxis.title.padding'
        }, 
        xAxisTitlePaddingBottom: {
            type: Number,
            kComposite: 'xAxis.title.padding.bottom'
        }, 
        xAxisTitlePaddingLeft: {
            type: Number,
            kComposite: 'xAxis.title.padding.left'
        }, 
        xAxisTitlePaddingRight: {
            type: Number,
            kComposite: 'xAxis.title.padding.right'
        }, 
        xAxisTitlePaddingTop: {
            type: Number,
            kComposite: 'xAxis.title.padding.top'
        }, 
        xAxisTitlePosition: {
            type: String,
            kComposite: 'xAxis.title.position'
        }, 
        xAxisTitleRotation: {
            type: Number,
            kComposite: 'xAxis.title.rotation'
        }, 
        xAxisTitleText: {
            type: String,
            kComposite: 'xAxis.title.text'
        }, 
        xAxisTitleVisible: {
            type: Boolean,
            kComposite: 'xAxis.title.visible'
        }, 
        xAxisTitleVisual: {
            type: Function,
            kComposite: 'xAxis.title.visual'
        }, 
        xAxisType: {
            type: String,
            kComposite: 'xAxis.type'
        }, 
        xAxisVisible: {
            type: Boolean,
            kComposite: 'xAxis.visible'
        }, 
        xAxisNotesPosition: {
            type: String,
            kComposite: 'xAxis.notes.position'
        }, 
        xAxisNotesIconBackground: {
            type: String,
            kComposite: 'xAxis.notes.icon.background'
        }, 
        xAxisNotesIconBorderColor: {
            type: String,
            kComposite: 'xAxis.notes.icon.border.color'
        }, 
        xAxisNotesIconBorderWidth: {
            type: Number,
            kComposite: 'xAxis.notes.icon.border.width'
        }, 
        xAxisNotesIconSize: {
            type: Number,
            kComposite: 'xAxis.notes.icon.size'
        }, 
        xAxisNotesIconType: {
            type: String,
            kComposite: 'xAxis.notes.icon.type'
        }, 
        xAxisNotesIconVisible: {
            type: Boolean,
            kComposite: 'xAxis.notes.icon.visible'
        }, 
        xAxisNotesLabelBackground: {
            type: String,
            kComposite: 'xAxis.notes.label.background'
        }, 
        xAxisNotesLabelBorderColor: {
            type: String,
            kComposite: 'xAxis.notes.label.border.color'
        }, 
        xAxisNotesLabelBorderDashType: {
            type: String,
            kComposite: 'xAxis.notes.label.border.dashType'
        }, 
        xAxisNotesLabelBorderWidth: {
            type: Number,
            kComposite: 'xAxis.notes.label.border.width'
        }, 
        xAxisNotesLabelColor: {
            type: String,
            kComposite: 'xAxis.notes.label.color'
        }, 
        xAxisNotesLabelFont: {
            type: String,
            kComposite: 'xAxis.notes.label.font'
        }, 
        xAxisNotesLabelTemplate: {
            type: String | Function,
            kComposite: 'xAxis.notes.label.template'
        }, 
        xAxisNotesLabelVisible: {
            type: Boolean,
            kComposite: 'xAxis.notes.label.visible'
        }, 
        xAxisNotesLabelRotation: {
            type: Number,
            kComposite: 'xAxis.notes.label.rotation'
        }, 
        xAxisNotesLabelFormat: {
            type: String,
            kComposite: 'xAxis.notes.label.format'
        }, 
        xAxisNotesLabelPosition: {
            type: String,
            kComposite: 'xAxis.notes.label.position'
        }, 
        xAxisNotesLineDashType: {
            type: String,
            kComposite: 'xAxis.notes.line.dashType'
        }, 
        xAxisNotesLineWidth: {
            type: Number,
            kComposite: 'xAxis.notes.line.width'
        }, 
        xAxisNotesLineColor: {
            type: String,
            kComposite: 'xAxis.notes.line.color'
        }, 
        xAxisNotesLineLength: {
            type: Number,
            kComposite: 'xAxis.notes.line.length'
        }, 
        xAxisNotesData: {
            type: Array,
            kComposite: 'xAxis.notes.data'
        },         xAxisNotesVisual: {
            type: Function,
            kComposite: 'xAxis.notes.visual'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/XAxis.js